export const phoneRegExp = /^\+[0-9]{1,15}$/;
//export const specialCharsRegExp = /^[A-Za-z0-9_ -.]*$/;
//export const spacesRegExp = /^[A-Za-z0-9_.-]*$/;
//export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
